import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SupportIcon(props: IconProps) {
    return <Icon {...props} iconKey={"support"}/>
}
